import { render, staticRenderFns } from "./aliyunExperiment.vue?vue&type=template&id=12728998&scoped=true&"
import script from "./aliyunExperiment.vue?vue&type=script&lang=js&"
export * from "./aliyunExperiment.vue?vue&type=script&lang=js&"
import style0 from "./aliyunExperiment.vue?vue&type=style&index=0&id=12728998&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12728998",
  null
  
)

export default component.exports